// queries/useGetRemixGallery.ts
"use client";
import { useInfiniteQuery, UseInfiniteQueryResult, InfiniteData } from "@tanstack/react-query";
import { fetch } from "libs";
import { GET_REMIX_GALLERY } from "api";
import { RemixGallery } from "types";

const fetchRemixGallery = async (
  pageParam: number = 1,
  pageSize: number = 20
): Promise<RemixGallery> => {
  return fetch(`${GET_REMIX_GALLERY}?page=${pageParam}&page_size=${pageSize}`);
};

export const useGetRemixGallery = (
  pageSize: number
): UseInfiniteQueryResult<InfiniteData<RemixGallery>, Error> => {
  // @ts-ignore
  return useInfiniteQuery<RemixGallery, Error>({
    queryKey: ["remixGallery"],
    queryFn: ({ pageParam = 1 }) => fetchRemixGallery(pageParam as any, pageSize),
    getNextPageParam: (lastPage, allPages) => {
      const nextPage = allPages.length + 1;
      return nextPage <= Math.ceil(lastPage.total_images / pageSize) ? nextPage : undefined;
    },
  });
};

export default useGetRemixGallery;
